import { closeTicketBody } from '@planuze/admin-contracts';
import { toast } from '@planuze/ui';
import { useSupportContent } from '../../content/sections/support.js';
import { useCloseTicket } from '../../hooks/use-tickets.js';
import { ReasonDialog } from '../reason-dialog.js';
import { ticketErrorMessage } from './ticket-error.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly ticketId: string;
}

export function CloseTicketModal({ open, onClose, ticketId }: Props) {
  const copy = useSupportContent();
  const close = useCloseTicket(ticketId);
  const confirm = (reason: string): void => {
    close.mutate(
      { closedReason: reason },
      {
        onSuccess: () => {
          toast.success(copy.closeModal.successToast);
          onClose();
        },
        onError: (err) => {
          toast.error(ticketErrorMessage(err, copy.ticketErrors));
        },
      },
    );
  };
  return (
    <ReasonDialog
      open={open}
      onClose={onClose}
      title={copy.closeModal.title}
      description={copy.closeModal.description}
      confirmLabel={copy.closeModal.confirmLabel}
      reasonLabel={copy.closeModal.reasonLabel}
      destructive
      pending={close.isPending}
      validate={(reason) => closeTicketBody.safeParse({ closedReason: reason }).success}
      onConfirm={confirm}
    />
  );
}
